import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de89d872bc897a/src/layout/home/homeContent.tsx");
